import { type FunctionComponent } from "react";

import type {
  BurgerMenuItem,
  BurgerMenuItemChildren,
} from "scmp-app/lib/app/hooks/scmp-pwa-burger-menu-config";

import NewsletterIcon from "./icon-newsletter.svg";
import { Children, Container, Item, ItemText, Label, NewTag, YellowDot } from "./styles";

type Props = {
  className?: string;
  items: BurgerMenuItem[];
};
export const MenuItemHighlight: FunctionComponent<Props> = ({ className, items }) => {
  const renderChildren = (children: BurgerMenuItemChildren[]) =>
    children.map((child, index) => {
      const getBulletStyle = () => {
        switch (child.bulletStyle) {
          case "newsletter":
            return <NewsletterIcon />;
          default:
            return <YellowDot />;
        }
      };
      return (
        <Item
          key={index}
          pathname={child.urlAlias ?? child.linkHref ?? ""}
          target={child.isExternal ? "_blank" : undefined}
        >
          {getBulletStyle()}
          <ItemText dangerouslySetInnerHTML={{ __html: child.text }} />
          {child.hasNewTag && <NewTag>NEW</NewTag>}
        </Item>
      );
    });

  return (
    <>
      {items.map((item, index) => (
        <Container className={className} key={index}>
          <Label>{item.text}</Label>
          {item?.children ? <Children>{renderChildren(item.children)}</Children> : null}
        </Container>
      ))}
    </>
  );
};
